import React from 'react';
import { connect } from 'react-redux';

import CampaignListingsComponent from '../../components/app/Campaign/CampaignListings';

import * as actions from '../../actions/campaign/campaignListings';

const CampaignListings = (props) => {
  return (
    <CampaignListingsComponent {...props} />
  );
};

export default connect(({ campaign }) => campaign.campaignListings, actions)(CampaignListings);

